import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import router from '../router'

const http = axios.create({
  baseURL: '/',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  transformRequest: [function (data, headers) {
    // transformRequest 允许在向服务器发送前，修改请求数据
    // 只能用在PUT、POST和PATCH这几个请求方法
    headers.token = store.state.home.token
    if (headers['Content-Type'] === 'multipart/form-data') {
      return data
    } else {
      return JSON.stringify(data)
    }
  }]
})

// 请求拦截器
http.interceptors.request.use(config => {
  return config
}, error => {
  Message.error({
    message: '请求失败'
  })
  return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(res => {
  return res.data
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 401:
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
        break
      // 403 服务器拒绝访问
      case 403:
        router.push('/error/403')
        break
      // 404 访问的资源不存在
      case 404:
        router.push('/error/404')
        break
      // 500 服务器错误
      case 500:
        router.push('/error/500')
        break
    }
    return Promise.reject(error)
  }
})

// 请求方法封装
function request (method, url, params, success, failure) {
  http({
    method,
    url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    withCredentials: true
  }).then(res => {
    if (res.code === 100000) {
      if (success) {
        success(res)
      }
    } else {
      if (failure) {
        failure(res)
      } else {
        window.alert('error: ' + qs.stringify(res.data))
      }
    }
  }).catch(err => {
    console.log(err)
  })
}

export default {
  GET: function (url, params, success, failure) {
    return request('GET', url, params, success, failure)
  },
  POST: function (url, params, success, failure) {
    return request('POST', url, params, success, failure)
  },
  PUT: function (url, params, success, failure) {
    return request('PUT', url, params, success, failure)
  },
  DELETE: function (url, params, success, failure) {
    return request('DELETE', url, params, success, failure)
  }
}



// WEBPACK FOOTER //
// ./src/common/request.js